import { PoaItem } from '../models'

type PoaDataProps = {
  proxyId?: string | null
  poa?: PoaItem | null
  poaIsEnabled?: boolean
  withPoa?: boolean | null
  poaDateStart?: string | null
  poaDateEnd?: string | null
}

export const getPoaDataToSign = ({
  proxyId,
  poa,
  poaIsEnabled,
  withPoa,
  poaDateStart,
  poaDateEnd,
}: PoaDataProps) => {
  if (!poaIsEnabled) {
    return {}
  }

  if (proxyId || poa?.poaIdInternal) {
    return {
      withPoa: withPoa || true,
      poaId: proxyId || poa?.poaIdInternal,
      poaDateStart: poaDateStart || poa?.issued,
      poaDateEnd: poaDateEnd || poa?.validUntil,
    }
  }

  return { withPoa: false }
}
